"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _orionContext = require("../orionContext/orionContext");

require("./floater.css");

require("./msp-provider.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Floater = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Floater, _React$Component);

  var _super = _createSuper(Floater);

  function Floater() {
    (0, _classCallCheck2["default"])(this, Floater);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Floater, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          show = _this$props.show,
          onShow = _this$props.onShow,
          onHide = _this$props.onHide; // Below condition is making sure that the event gets fired on prop change only

      if (prevProps.show === show) {
        return;
      }

      (0, _setTimeout2["default"])(function () {
        if (show) {
          onShow();
        } else {
          onHide();
        }
      }, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dataTestId = _this$props2.dataTestId,
          position = _this$props2.position,
          show = _this$props2.show,
          children = _this$props2.children,
          overlay = _this$props2.overlay,
          onOverlayClick = _this$props2.onOverlayClick;

      var _ref = this.context || {},
          dellDoubleHeader = _ref.dellDoubleHeader;

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          "data-testid": dataTestId,
          className: (0, _utils.gatherClasses)(this.props, "oui-floater", dellDoubleHeader && "oui-double-header-support", "oui-float-".concat(position), show ? "oui-show" : null)
        }, children), overlay && show ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-overlay",
          onClick: onOverlayClick,
          "aria-hidden": "true"
        }) : null)
      );
    }
  }]);
  return Floater;
}(_react["default"].Component);

Floater.contextType = _orionContext.OrionContext;
Floater.propTypes = {
  position: _propTypes["default"].oneOf(["left", "right"]),
  show: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  onOverlayClick: _propTypes["default"].func,
  onShow: _propTypes["default"].func,
  onHide: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
Floater.defaultProps = {
  position: "left",
  show: false,
  overlay: false,
  onShow: function onShow() {},
  onHide: function onHide() {},
  dataTestId: "orion-floater"
};
Floater.displayName = "OrionFloater";
var _default = Floater;
exports["default"] = _default;